import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Box, Container } from '@material-ui/core';

import Greeting from '../../components/Greeting';
import PageTitle from '../../components/PageTitle';
import Loading from '../../components/Loading';
import ProductsAvailableToScheduling from '../../containers/ProductsAvailableToScheduling';
import ProductsAlreadyScheduled from '../../containers/ProductsAlreadyScheduled';

import SchedulingStore from '../../stores/SchedulingStore';

class Schedules extends Component {
  async componentDidMount() {
    const { schedulingStore } = this.props;
    const { getAllSchedules } = schedulingStore;

    await getAllSchedules();
  }

  render() {
    const { schedulingStore } = this.props;
    const {
      isLoading,
      productsAvailableToScheduling,
      productsAlreadyScheduled,
      productsAlreadyScheduledAndGroupedByDate,
      data: { customer },
    } = schedulingStore;

    return (
      <>
        {isLoading && <Loading />}

        <Box mt={5} mb={8}>
          <Container>
            <Greeting name={customer.name} />
            <PageTitle title="Central de Montagem" />

            {productsAvailableToScheduling.length > 0 && (
              <ProductsAvailableToScheduling
                productsAvailableToScheduling={productsAvailableToScheduling}
              />
            )}

            {productsAlreadyScheduled.length > 0 && (
              <ProductsAlreadyScheduled
                productsAlreadyScheduledAndGroupedByDate={
                  productsAlreadyScheduledAndGroupedByDate
                }
              />
            )}
          </Container>
        </Box>
      </>
    );
  }
}

Schedules.propTypes = {
  schedulingStore: PropTypes.instanceOf(SchedulingStore).isRequired,
};

export default inject('schedulingStore')(observer(Schedules));
